// SuggestedPostFeed.js
import { connect } from 'react-redux';

import {
  SUGGESTED_POST_FEED,
  FOLLOWING_PREFETCHED_MESSAGE_AMOUNT,
} from '../RemoteConfigKeys.js';

import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import setMessageHeightInFeed from '../action/setMessageHeightInFeed.js';

import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import SuggestedPostFeed from '../component/SuggestedPostFeed.jsx';

const mapStateToProps = state => {
  const feedName = getRemoteConfigData(state, SUGGESTED_POST_FEED);
  const feedType = getReturnType({ feedName: feedName });
  const selectPath = ['home', feedType, feedName];
  const nextPage = getListData(state, selectPath, 'nextPage');
  return {
    feedName,
    prefetchedMessageAmount: getRemoteConfigData(
      state,
      FOLLOWING_PREFETCHED_MESSAGE_AMOUNT
    ),
    postIds: getListData(state, selectPath, 'itemIds'),
    meId: getMeData(state, 'id'),
    currentAutoplayPostId: getOperationData(
      state,
      ['feed'],
      'currentAutoplayPostId'
    ),
    isFirstPageFetching: !!getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetching'
    ),
    isNextPageFetching: !!getNetworkingData(
      state,
      [...selectPath, nextPage],
      'isFetching'
    ),
    nextPage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: ({ type, page }) => dispatch(fetchFeeds({ type, page })),
    setMessageHeightInFeed: ({ feedName, messageObject }) =>
      dispatch(
        setMessageHeightInFeed({
          feedName,
          messageObject,
        })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuggestedPostFeed);
